<product-myo [options]="productMYOOptions" (myoClose)="closeDialog()" (myoSubmit)="onSubmit($event)"></product-myo>
